export const items = [
    {
      label: "Vendor Estimate Request",
      key: "9",
    },
    {
      label: "Owner Approval",
      key: "10",
    },
  ];

  const handleEstimateMenuClick = (e) => {
    console.log("click", e);
  };

  export const estimateMenu = {
    items,
    onClick: handleEstimateMenuClick,
  };